export type BaseTextInputSize = 'default' | 'small' | 'large';

export const getInputsizeSettings = (size: BaseTextInputSize) => {
  switch (size) {
    case 'small':
      return {
        height: 36,
        fontSize: 13
      };
    case 'large':
      return {
        height: 150,
        fontSize: 13
      };
    default:
      return {
        height: 44,
        fontSize: 15
      };
  }
};
